var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { styleBlock } from "../styleBlock";
import EyeCrossedIcon from "../assets/icons/Eye Crossed.svg";
import EyeIcon from "../assets/icons/Eye.svg";
const InputPassword = (_a) => {
    var { className, feedbackValid, feedbackInvalid, translateFunc } = _a, inputProps = __rest(_a, ["className", "feedbackValid", "feedbackInvalid", "translateFunc"]);
    const [showPassword, toggleShowPassword] = useState(false);
    const [value, setValue] = useState(inputProps.value || "");
    const b = styleBlock("input-password");
    function handleChange(e) {
        setValue(e.target.value);
        if (inputProps.onChange) {
            inputProps.onChange(e);
        }
    }
    return (React.createElement("div", { className: b.toString() + " " + className },
        React.createElement("div", { className: "position-relative" },
            React.createElement(Form.Control, Object.assign({ isInvalid: !!feedbackInvalid }, inputProps, { value: value, type: showPassword ? "text" : "password", onChange: handleChange })),
            React.createElement("div", { className: "input-inner-element" },
                React.createElement("button", { tabIndex: -1, type: "button", onClick: () => toggleShowPassword(!showPassword), className: "d-block border-0 p-0 m-0 bg-transparent cursor-pointer", "aria-label": translateFunc(`password.${showPassword ? "hide" : "show"}`) },
                    React.createElement("img", { src: showPassword ? EyeCrossedIcon : EyeIcon, className: "d-block", role: "presentation" })))),
        feedbackValid && React.createElement(Form.Control.Feedback, null, feedbackValid),
        feedbackInvalid && React.createElement(Form.Control.Feedback, { type: "invalid", dangerouslySetInnerHTML: { __html: feedbackInvalid } })));
};
export default InputPassword;
//# sourceMappingURL=index.js.map